import initialState from "./stormwater.state.js";
import actions from "./stormwater.actions.js";
import mutations from "./stormwater.mutations.js";
import getters from "./stormwater.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
